import { FaTimes } from "react-icons/fa";

import { useDashboardContext } from "@/layouts/dashboard-layout";

import { SmallSidebarWrapper } from "@/components/wrappers";

import { Logo, NavLinks } from ".";

const SmallSidebar = () => {
  const { toggleSidebar, sidebar } = useDashboardContext();

  return (
    <SmallSidebarWrapper>
      <div className={`sidebar-container ${sidebar ? "show-sidebar" : ""}`}>
        <div className="content">
          <button className="close-btn" type="button" onClick={toggleSidebar}>
            <FaTimes />
          </button>
          <header>
            <Logo />
          </header>
          <NavLinks />
        </div>
      </div>
    </SmallSidebarWrapper>
  );
};

export default SmallSidebar;
